import React from 'react';

export default function ListingFeatures({features = {}, rules}) {
    const items = [
        ['Space Area', 'square_foot', features.area],
        ['Space Security', 'lock_outline', features.security],
        ['Space Access', 'vpn_key', features.access],
        ['Space rules', 'rule', rules]
    ].map(([label, icon, value]) => ({
        label, icon,
        value: (Array.isArray(value) ? value : [value])
            .filter(value => typeof value === 'string' || typeof value === 'number')
            .map(value => String(value).trim())
            .filter(value => value && (label !== 'Space Security' || value.toLowerCase() !== 'none')).join(', ')
    })).filter(item => item.value);

    if (!items.length) return null;

    return (
        <ul className="listing-feature-grid">
            {items.map(({label, icon, value}) => (
                <li key={label} title={label}>
                    <span className="material-icons" aria-hidden="true">{icon}</span>
                    <span><span className="sr-only">{label}: </span>{value}</span>
                </li>
            ))}
        </ul>
    );
}
